import { useEffect, useId, useState } from "react";
import type { IndustryOption } from "../api/types";

export function IndustryPicker({ value, options, onChange, onSearchIndustries }: { value: { code: string; name: string }; options: IndustryOption[]; onChange: (value: { code: string; name: string }) => void; onSearchIndustries: (query: string) => void }) {
  const choices = options.some((item) => item.code === value.code) ? options : [{ code: value.code, name: value.name }, ...options];
  const format = (industry: { code: string; name: string }) => `${industry.code} · ${industry.name}`;
  const [query, setQuery] = useState(() => format(value));
  const listId = useId();
  useEffect(() => setQuery(format(value)), [value.code, value.name]);
  const update = (nextQuery: string) => {
    setQuery(nextQuery);
    onSearchIndustries(nextQuery);
    const selected = choices.find((item) => item.code === nextQuery || format(item) === nextQuery);
    if (selected) onChange({ code: selected.code, name: selected.name });
  };
  return <label><span>国标行业</span><input aria-label="国标行业" list={listId} value={query} placeholder="搜索或选择行业代码、名称" onChange={(event) => update(event.target.value)} /><datalist id={listId}>{choices.map((item) => <option key={item.code} value={format(item)} />)}</datalist></label>;
}
